"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _Tooltip = _interopRequireDefault(require("./Tooltip"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "tooltip-wrap": "DefaultTheme__tooltip-wrap___2Y4Yy",
  "tooltip": "DefaultTheme__tooltip___n3ADt",
  "tooltip-visible": "DefaultTheme__tooltip-visible___3TKRE",
  "tooltip-position-top": "DefaultTheme__tooltip-position-top___10DA7",
  "tooltip-position-bottom": "DefaultTheme__tooltip-position-bottom___M5eAs",
  "tooltip-position-left": "DefaultTheme__tooltip-position-left___1s_GA",
  "tooltip-position-right": "DefaultTheme__tooltip-position-right___2Gf_i",
  "tooltip-primary": "DefaultTheme__tooltip-primary___2C6k0",
  "tooltip-text": "DefaultTheme__tooltip-text___1rrAD",
  "tooltip-children-wrapper": "DefaultTheme__tooltip-children-wrapper___3g6MD",
  "tooltip-inner-multi-line": "DefaultTheme__tooltip-inner-multi-line___18OSR",
  "tooltipWrap": "DefaultTheme__tooltip-wrap___2Y4Yy",
  "tooltipVisible": "DefaultTheme__tooltip-visible___3TKRE",
  "tooltipPositionTop": "DefaultTheme__tooltip-position-top___10DA7",
  "tooltipPositionBottom": "DefaultTheme__tooltip-position-bottom___M5eAs",
  "tooltipPositionLeft": "DefaultTheme__tooltip-position-left___1s_GA",
  "tooltipPositionRight": "DefaultTheme__tooltip-position-right___2Gf_i",
  "tooltipPrimary": "DefaultTheme__tooltip-primary___2C6k0",
  "tooltipText": "DefaultTheme__tooltip-text___1rrAD",
  "tooltipChildrenWrapper": "DefaultTheme__tooltip-children-wrapper___3g6MD",
  "tooltipInnerMultiLine": "DefaultTheme__tooltip-inner-multi-line___18OSR"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "tooltip": "DarkTheme__tooltip___2_edM"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "tooltip": "LumeTheme__tooltip___31wmx"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)('Tooltip', themes.DefaultTheme)(_Tooltip["default"]);
ThemedComponent.displayName = 'Tooltip';
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map